import { Box } from "@mui/material";
import { Toast } from "primereact/toast";
import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import veg from "../Assets/product_management/Foodmark.svg"
import nonVeg from "../Assets/product_management/non-veg.svg"
import { useState } from "react";
import { useEffect } from "react";
import { Typography } from "@mui/material";
import { blobSrc } from '../utils/blobUrl';
import { offerSavings, orderTotalsRows, planLines } from '../utils/orderTotals';

export function OrderProductsTable({ expanded = false }) {
    const toast = useRef(null);
    const orderedProducts = useSelector(state => state.orders.orderDetails);
    const [ordersDetails,setOrdersDetails] = useState({})
    useEffect(()=>{
        setOrdersDetails(orderedProducts)
    },[orderedProducts])
    console.log(orderedProducts)
    let serialNo = 1
    const calculateItemPrice = (price, tax) => {
        const txRemovePrice = (parseFloat(price) * parseFloat(tax)) / 100;
        const itemPrice = parseFloat(price) - parseFloat(txRemovePrice);
        return itemPrice.toFixed(2); // Returns a string rounded to 2 decimal places
    };


    const getLineInstructions = (cartItem, prd) => {
        const line = Array.isArray(prd.instructions) ? prd.instructions.filter(Boolean) : [];
        if (line.length) return [...new Set(line)];                
        return [];                                                  
    };

    // pretty print list
    const renderInstr = (arr) => (arr.length ? arr.join(", ") : "—");

        

    return (<Box>
        <Toast ref={toast} />
            <TableContainer sx={{ 
                height: expanded ? "auto" : { xs: "35vh", sm: "40vh", md: "300px" },
                minHeight: expanded ? { xs: "35vh", md: "300px" } : undefined,
                maxHeight: expanded ? { xs: "60vh", md: "calc(100vh - 320px)" } : { xs: "45vh", sm: "45vh", md: "320px" },
                overflowX: 'auto',
                overflowY: 'auto',
                '&::-webkit-scrollbar': {
                    height: { xs: '4px', sm: '8px' },
                    width: { xs: '4px', sm: '8px' },
                },
                '&::-webkit-scrollbar-track': {
                    backgroundColor: '#f1f1f1',
                },
                '&::-webkit-scrollbar-thumb': {
                    backgroundColor: '#888',
                    borderRadius: '4px',
                },
            }}>
            <Table stickyHeader aria-label="sticky table" sx={{ minWidth: { xs: 800, sm: 650 } }}>
                <TableHead style={{ backgroundColor: "background.upload" }}>
                    <TableRow >
                    <TableCell sx={{ 
                            fontWeight: "600", 
                            textAlign: "left", 
                            backgroundColor: "background.upload",
                            fontSize: { xs: "10px", sm: "12px", md: "14px" },
                            padding: { xs: "6px 4px", sm: "8px", md: "16px" },
                            whiteSpace: "nowrap"
                        }} align="left">S No</TableCell>
                        <TableCell sx={{ 
                            fontWeight: "600", 
                            textAlign: "left", 
                            backgroundColor: "background.upload",
                            fontSize: { xs: "10px", sm: "12px", md: "14px" },
                            padding: { xs: "6px 4px", sm: "8px", md: "16px" },
                            whiteSpace: "nowrap"
                        }} align="left">Product Name</TableCell>
                        <TableCell sx={{ 
                            fontWeight: "600", 
                            textAlign: "left", 
                            backgroundColor: "background.upload",
                            fontSize: { xs: "10px", sm: "12px", md: "14px" },
                            padding: { xs: "6px 4px", sm: "8px", md: "16px" },
                            whiteSpace: "nowrap"
                        }} align="left">Product Instruction</TableCell>
                        <TableCell sx={{ 
                            fontWeight: "600", 
                            textAlign: "left", 
                            backgroundColor: "background.upload",
                            fontSize: { xs: "10px", sm: "12px", md: "14px" },
                            padding: { xs: "6px 4px", sm: "8px", md: "16px" },
                            whiteSpace: "nowrap"
                        }} align="left">Main product</TableCell>
                        <TableCell sx={{ 
                            fontWeight: "600", 
                            textAlign: "left", 
                            backgroundColor: "background.upload",
                            fontSize: { xs: "10px", sm: "12px", md: "14px" },
                            padding: { xs: "6px 4px", sm: "8px", md: "16px" },
                            whiteSpace: "nowrap"
                        }} align="left">Criteria</TableCell>
                        <TableCell sx={{ 
                            fontWeight: "600", 
                            textAlign: "left", 
                            backgroundColor: "background.upload",
                            fontSize: { xs: "10px", sm: "12px", md: "14px" },
                            padding: { xs: "6px 4px", sm: "8px", md: "16px" },
                            whiteSpace: "nowrap"
                        }} align="left">Capacity</TableCell>
                        <TableCell sx={{ 
                            fontWeight: "600", 
                            textAlign: "left", 
                            backgroundColor: "background.upload",
                            fontSize: { xs: "10px", sm: "12px", md: "14px" },
                            padding: { xs: "6px 4px", sm: "8px", md: "16px" },
                            whiteSpace: "nowrap"
                        }} align="left">Quantity</TableCell>
                        {/* <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Price in Rs</TableCell> */}
                        <TableCell sx={{ 
                            fontWeight: "600", 
                            textAlign: "left", 
                            backgroundColor: "background.upload",
                            fontSize: { xs: "10px", sm: "12px", md: "14px" },
                            padding: { xs: "6px 4px", sm: "8px", md: "16px" },
                            whiteSpace: "nowrap"
                        }} align="left">Special Offer</TableCell>
                        <TableCell sx={{ 
                            fontWeight: "600", 
                            textAlign: "left", 
                            backgroundColor: "background.upload",
                            fontSize: { xs: "10px", sm: "12px", md: "14px" },
                            padding: { xs: "6px 4px", sm: "8px", md: "16px" },
                            whiteSpace: "nowrap"
                        }} align="left">GST %</TableCell>
                        <TableCell sx={{ 
                            fontWeight: "600", 
                            textAlign: "left", 
                            backgroundColor: "background.upload",
                            fontSize: { xs: "10px", sm: "12px", md: "14px" },
                            padding: { xs: "6px 4px", sm: "8px", md: "16px" },
                            whiteSpace: "nowrap"
                        }} align="left">Total Price in Rs</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                {ordersDetails?.cart_items?.map((item) => {
                        return (<> {
                            item.products.map((prd,index)=>(
                                prd.capacity?.map((capacity,ind) =>{
                                    if (capacity.item_quantity>0){
                                    const selected_capacity = item.product_details.find(obj1=> item.products.some(obj2=>prd.product_id===obj1.id))
                                    console.log(selected_capacity)
                                    const selected_product = item.products.find(obj1=> item.product_details.some(obj2=>obj2.id===prd.product_id))
                                    console.log(selected_product)

                                        // Find the main product for addon products only
                                        const isAddonProduct = selected_capacity?.item_category === 'Addon';

                                        let mainProduct = null;
                                        if (isAddonProduct) {
                                            const parentId = prd.main_product_id;
                                            mainProduct = item.product_details.find(pd => pd.id === parentId);
                                        }

                                    const instr = getLineInstructions(item, prd); 
                                    return(
                                         capacity.item_quantity!==""&&<TableRow key={item.id} >
                               <TableCell sx={{ 
                                    textAlign: "left", 
                                    textTransform: "capitalize", 
                                    backgroundColor: "white",
                                    fontSize: { xs: "10px", sm: "12px", md: "14px" },
                                    padding: { xs: "6px 4px", sm: "8px", md: "16px" }
                                }}>{serialNo++}</TableCell>
                                <TableCell sx={{ 
                                    textAlign: "left", 
                                    textTransform: "capitalize", 
                                    backgroundColor: "white",
                                    fontSize: { xs: "10px", sm: "12px", md: "14px" },
                                    padding: { xs: "6px 4px", sm: "8px", md: "16px" }
                                }}> {<Box sx={{ display: "flex", alignItems: "center" }}><Box component='img' src={blobSrc(selected_capacity?.image_urls?.[0])} sx={{ width: { xs: "28px", sm: "36px", md: "40px" }, height: { xs: "28px", sm: "36px", md: "40px" }, borderRadius: "8px", marginRight: { xs: "6px", sm: "8px", md: "10px" } }}/><Typography sx={{ fontSize: { xs: "10px", sm: "12px", md: "14px" } }}>{selected_capacity.item_name}</Typography></Box>}</TableCell>
                                <TableCell sx={{ 
                                    textAlign: "left", 
                                    backgroundColor: "white",
                                    fontSize: { xs: "9px", sm: "11px", md: "14px" },
                                    padding: { xs: "6px 4px", sm: "8px", md: "16px" }
                                }}>{renderInstr(instr)}</TableCell>
                                <TableCell sx={{ 
                                    textAlign: "left", 
                                    textTransform: "capitalize", 
                                    backgroundColor: "white",
                                    fontSize: { xs: "10px", sm: "12px", md: "14px" },
                                    padding: { xs: "6px 4px", sm: "8px", md: "16px" }
                                }}>{isAddonProduct ? (mainProduct?.item_name || "—") : "—"}</TableCell>
                                <TableCell sx={{ 
                                    textAlign: "left", 
                                    textTransform: "capitalize", 
                                    backgroundColor: "white",
                                    fontSize: { xs: "10px", sm: "12px", md: "14px" },
                                    padding: { xs: "6px 4px", sm: "8px", md: "16px" }
                                }}>{selected_capacity.item_criteria=='veg'?<Box sx={{ display: "flex", alignItems: "center", gap: { xs: "4px", sm: "6px" } }}><Box component='img' src={veg} sx={{ width: { xs: "12px", sm: "16px" }, height: { xs: "12px", sm: "16px" } }}/><Typography sx={{ fontSize: { xs: "9px", sm: "11px", md: "14px" } }}>Veg</Typography></Box>:<Box sx={{ display: "flex", alignItems: "center", gap: { xs: "4px", sm: "6px" } }}><Box component='img' src={nonVeg} sx={{ width: { xs: "12px", sm: "16px" }, height: { xs: "12px", sm: "16px" } }}/><Typography sx={{ fontSize: { xs: "9px", sm: "11px", md: "14px" } }}>Non - Veg</Typography></Box>}</TableCell>
                                <TableCell sx={{ 
                                    textAlign: "left", 
                                    textTransform: "capitalize", 
                                    backgroundColor: "white",
                                    fontSize: { xs: "10px", sm: "12px", md: "14px" },
                                    padding: { xs: "6px 4px", sm: "8px", md: "16px" }
                                }}>{capacity.item_capacity}</TableCell>
                                <TableCell sx={{ 
                                    textAlign: "left", 
                                    textTransform: "capitalize", 
                                    backgroundColor: "white",
                                    fontSize: { xs: "10px", sm: "12px", md: "14px" },
                                    padding: { xs: "6px 4px", sm: "8px", md: "16px" }
                                }}>{capacity.item_quantity}</TableCell>
                                {/* <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>Rs {selected_capacity.capacitydetails[0].item_offers_price!=0?(parseFloat(capacity.item_quantity)*(parseFloat(calculateItemPrice(selected_capacity.capacitydetails[0].item_offers_price, capacity.item_tax)))).toFixed(2):(parseInt(capacity.item_quantity)*(calculateItemPrice(selected_capacity.capacitydetails[0].item_selling_price, capacity.item_tax))).toFixed(2)}</TableCell> */}
                                <TableCell sx={{ 
                                    textAlign: "left", 
                                    textTransform: "capitalize", 
                                    backgroundColor: "white",
                                    color:selected_capacity.bogo_details===true||parseFloat(capacity.item_selling_price)==0.00&&"green",
                                    fontWeight:selected_capacity.bogo_details===true||parseFloat(capacity.item_selling_price)==0.00&&"700",
                                    fontSize: { xs: "9px", sm: "11px", md: "14px" },
                                    padding: { xs: "6px 4px", sm: "8px", md: "16px" }
                                }}>{selected_capacity.bogo_details===true?"Buy 1 Get 1 Free":parseFloat(capacity.item_offers_price)>0?capacity.item_special_offer+"% Off":parseFloat(capacity.item_selling_price)==0.00?"Free":"--"}</TableCell>
                                <TableCell sx={{ 
                                    textAlign: "left", 
                                    textTransform: "capitalize", 
                                    backgroundColor: "white",
                                    fontSize: { xs: "10px", sm: "12px", md: "14px" },
                                    padding: { xs: "6px 4px", sm: "8px", md: "16px" }
                                }}>{capacity.item_tax} %</TableCell>
                                <TableCell sx={{ 
                                    textAlign: "left", 
                                    textTransform: "capitalize", 
                                    backgroundColor: "white",
                                    fontSize: { xs: "10px", sm: "12px", md: "14px" },
                                    padding: { xs: "6px 4px", sm: "8px", md: "16px" }
                                }}>Rs {capacity.item_offers_price!=0?(parseFloat(capacity.item_quantity)*parseFloat(capacity.item_offers_price)).toFixed(2):(parseFloat(capacity?.item_quantity)*parseFloat(capacity.item_selling_price)).toFixed(2)}</TableCell>
                                </TableRow>
                                )}
                    })
                            ))
                            }</>)
                    })

                    }

                    {/*
                      THE PLAN BOUGHT WITH THIS ORDER, AS A LINE ITEM.

                      The loop above walks products, and a membership is not
                      one, so a Rs 600 Gold plan appeared nowhere in this list
                      -- only as a "Subscription" row in the totals below, on a
                      table whose line items came to exactly that much less than
                      the bill printed under them.

                      The wording matches the app's Track Order panel and the
                      printed bill. `planLines` is the port of bill_ticket.py's
                      plan_lines, for the same reason orderTotals is a port of
                      invoice_totals: one rule written twice beats two documents
                      that disagree.
                    */}
                    {planLines(ordersDetails).map((plan, idx) => (
                        <TableRow key={`plan-${plan.name}-${idx}`}>
                            <TableCell sx={{ textAlign: "left", fontSize: { xs: "10px", sm: "12px", md: "14px" }, padding: { xs: "6px 4px", sm: "8px", md: "16px" } }}>{serialNo++}</TableCell>
                            <TableCell sx={{ textAlign: "left", fontSize: { xs: "10px", sm: "12px", md: "14px" }, padding: { xs: "6px 4px", sm: "8px", md: "16px" } }}>
                                <Typography sx={{ fontSize: { xs: "10px", sm: "12px", md: "14px" }, fontWeight: 500 }}>{plan.name}</Typography>
                                <Typography sx={{ fontSize: { xs: "9px", sm: "10px", md: "11px" }, color: "#6B7280" }}>Membership bought with this order</Typography>
                            </TableCell>
                            <TableCell sx={{ textAlign: "left", fontSize: { xs: "10px", sm: "12px", md: "14px" }, padding: { xs: "6px 4px", sm: "8px", md: "16px" } }}>&mdash;</TableCell>
                            <TableCell sx={{ textAlign: "left", fontSize: { xs: "10px", sm: "12px", md: "14px" }, padding: { xs: "6px 4px", sm: "8px", md: "16px" } }}>&mdash;</TableCell>
                            <TableCell sx={{ textAlign: "left", fontSize: { xs: "10px", sm: "12px", md: "14px" }, padding: { xs: "6px 4px", sm: "8px", md: "16px" } }}>&mdash;</TableCell>
                            <TableCell sx={{ textAlign: "left", fontSize: { xs: "10px", sm: "12px", md: "14px" }, padding: { xs: "6px 4px", sm: "8px", md: "16px" }, whiteSpace: "nowrap" }}>{plan.days > 0 ? `${plan.days} days` : "\u2014"}</TableCell>
                            <TableCell sx={{ textAlign: "left", fontSize: { xs: "10px", sm: "12px", md: "14px" }, padding: { xs: "6px 4px", sm: "8px", md: "16px" } }}>1</TableCell>
                            <TableCell sx={{ textAlign: "left", fontSize: { xs: "10px", sm: "12px", md: "14px" }, padding: { xs: "6px 4px", sm: "8px", md: "16px" }, whiteSpace: "nowrap" }}>{plan.detail || "\u2014"}</TableCell>
                            <TableCell sx={{ textAlign: "left", fontSize: { xs: "10px", sm: "12px", md: "14px" }, padding: { xs: "6px 4px", sm: "8px", md: "16px" } }}>&mdash;</TableCell>
                            <TableCell sx={{ textAlign: "left", fontSize: { xs: "10px", sm: "12px", md: "14px" }, padding: { xs: "6px 4px", sm: "8px", md: "16px" }, whiteSpace: "nowrap" }}>Rs {plan.amount.toFixed(2)}</TableCell>
                        </TableRow>
                    ))}

                    {/*
                      THE WHOLE BILL, NOT ONE ROW OF IT.

                      This block used to print exactly one line -- the platform
                      fee -- and nothing else: no subtotal, no GST, no delivery,
                      no loyalty, wallet, bonus or subscription, and no grand
                      total. Nobody looking at an order here could reconcile it
                      against what the customer paid, or against the invoice
                      already emailed to them.

                      Rows come from orderTotals, a port of the invoice's own
                      builder. `Checkout.amount` is not a subtotal -- it is
                      already net of loyalty, the coupon, the waiver, wallet and
                      bonus -- so the subtotal is reconstructed before any
                      deduction is printed, and the block reconciles by
                      construction rather than by inspection.
                    */}
                    {orderTotalsRows(ordersDetails).rows.map((row) => (
                        <TableRow key={row.label}>
                            <TableCell
                                /*
                                 * NINE, not eight.
                                 *
                                 * The header renders TEN columns and each
                                 * totals row is a label plus one value, so a
                                 * span of eight put every figure under "GST %"
                                 * with an empty cell after it. The arithmetic
                                 * was right, which is why the column was never
                                 * noticed.
                                 */
                                colSpan={9}
                                align="right"
                                sx={{
                                    fontWeight: row.kind === 'total' ? 700 : 600,
                                    borderTop: row.kind === 'total' ? '2px solid rgba(0,0,0,0.35)' : undefined,
                                    color: row.kind === 'deduction' ? '#0B7A5E' : undefined,
                                }}
                            >
                                {row.label}
                            </TableCell>
                            <TableCell
                                align="left"
                                sx={{
                                    fontWeight: row.kind === 'total' ? 700 : 600,
                                    borderTop: row.kind === 'total' ? '2px solid rgba(0,0,0,0.35)' : undefined,
                                    color: row.kind === 'deduction' ? '#0B7A5E' : undefined,
                                    whiteSpace: 'nowrap',
                                }}
                            >
                                Rs {row.value}
                            </TableCell>
                        </TableRow>
                    ))}

                    {/*
                      WHAT THE HUB GAVE AWAY, matching the printed bill.

                      Below the total and OUTSIDE the sum: `reconciles` walks
                      every row but the last, so a savings line among them would
                      break the one property this block guarantees. The coupon,
                      the member offer and the pickup waiver -- not loyalty,
                      wallet or bonus, which are the customer's own balance
                      being spent.
                    */}
                    {offerSavings(ordersDetails) > 0 && (
                        <TableRow>
                            <TableCell
                                colSpan={9}
                                align="right"
                                sx={{ fontWeight: 600, color: '#9A4B10', borderBottom: 'none' }}
                            >
                                You saved
                            </TableCell>
                            <TableCell
                                align="left"
                                sx={{ fontWeight: 600, color: '#9A4B10', whiteSpace: 'nowrap', borderBottom: 'none' }}
                            >
                                Rs {offerSavings(ordersDetails).toFixed(2)}
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    </Box>)
}